<div class="new-template">
  <risk-card (onPolicyChange)="onPolicyChange($event)" [newCard]="true">
    <div card-header class="card-header">
      <div class="header-content">
        <div class="header-top">
          <div class="header-left">
            <div class="header-title">
              <div class="header-year" data-cy="propertyPolicyAddress">
                {{ policy?.riskLocationAddress?.addressLine1 }}
              </div>
              <!-- <div class="header-name">{{ vehicle.make }} {{ vehicle.model }}</div> -->
            </div>
          </div>

          <div class="pilet">
            <div class="pilet-text icon-complete" data-cy="propertyPolicyActiveHeader">Active</div>
          </div>
        </div>
      </div>
    </div>
    <div card-body class="card-body">
      <div class="grid-container">
        <!-- Row 1 -->
        <div class="row">
          <div class="grid-cell">
            <div class="label" data-cy="propertyPolicyNumberTitle">Policy Number</div>
            <div class="value" data-cy="propertyPolicyNumber">{{ policy | prettyPolicyNum }}</div>
          </div>
          <div class="grid-cell">
            <div class="canceldate-value">
              <div class="label" data-cy="propertyPolicyEffectiveDatesTitle">Effective Dates</div>
              @if (policy.cancelDate) {
                <div class="pilet">
                  <div class="pilet-text">Updated</div>
                </div>
              }
            </div>
            @if (!policy.cancelDate) {
              <div class="value" data-cy="propertyPolicyStartEndDate">
                {{ policy.periodStartDate | date: 'MM/dd/yyyy' }} -
                {{ policy.periodEndDate | date: 'MM/dd/yyyy' }}
              </div>
            }
            @if (policy.cancelDate) {
              <div class="value" data-cy="propertyPolicyStartEndDate">
                {{ policy.periodStartDate | date: 'MM/dd/yyyy' }} -
                {{ policy.cancelDate | date: 'MM/dd/yyyy' }}
              </div>
            }
          </div>
        </div>

        <div class="row">
          @if (thirdPartyInterest.length > 0) {
            @if (tpiEnabled) {
              <div class="grid-cell">
                <div
                  dsContent
                  [contentPath]="'policy.thirdPartyInterest.billing.cardSubHeader'"
                  class="label"
                  [options]="{ multiple: thirdPartyInterest.length > 1 }"
                ></div>
                <div class="value">
                  @for (thirdParty of thirdPartyInterest; track thirdParty) {
                    <p class="clamp" data-cy="propertyPolicyThirdPartyName">
                      {{ thirdParty.name | slice: 0 : 80 }}
                    </p>
                  }
                </div>
              </div>
            } @else {
              <div class="grid-cell">
                <div class="label" data-cy="propertyPolicyThirdPartyInterestHeader">
                  Third Party Interest
                </div>
                @for (thirdParty of thirdPartyInterest; track thirdParty) {
                  <div class="value" data-cy="propertyPolicyThirdPartyInterest">
                    {{ thirdParty.name }}
                  </div>
                }
              </div>
            }
          }
          <div class="grid-cell">
            <div class="label" data-cy="propertyPolicyFullAddressTitle">Full Address</div>
            <div class="flex">
              <div class="value" data-cy="propertyPolicyFullAddress">
                {{ policy.riskLocationAddress | address }}
              </div>
              <div class="pad-horizontal-10">
                @if (linkAddressChange) {
                  <a
                    [routerLink]="['/policies/changerequest']"
                    [state]="addressChangeState"
                    class="flex items-center justify-center no-decoration"
                    >Edit <i class="icon-chevron-right-thick pad-left-4"></i
                  ></a>
                }
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="image-container">
        <img src="/assets/images/property.svg" />
      </div>
    </div>

    <div class="card-footer" card-footer>
      @if (showDocuments) {
        <a data-cy="get-documents-link" (click)="onDocumentsClicked()">
          <span class="icon icon-documents"></span>
          <span>Get Documents</span>
        </a>
      }
      @if (tpiRequestChangeEnabled && thirdPartyInterest.length > 0) {
        <a (click)="OnEditLender()" [attr.aria-label]="'View Account'" data-cy="editLenderInfo">
          <span class="icon-edit"></span>
          <span>Edit Lender Info</span>
        </a>
      }

      @if (isFnolAuthorized$ | async) {
        <a data-cy="file-a-claim" (click)="fileAClaim()">
          <span class="icon-plus-thick"></span>
          <span>File a Claim</span>
        </a>
      }
      <a data-cy="request-policy-change-link" (click)="requestPolicyChange()">
        <span class="icon-refresh-reset"></span>
        <span>Request a Policy Update</span>
      </a>
    </div>
  </risk-card>
</div>
